import { MachinesInput } from './machines-input'
import { MaterialsInput } from './materials-input'
import { ThemesInput } from './themes-input'
import { SkillLevelSelection } from './skill-level-selection'
import { InstructionSection } from './instruction-section'
export const OptionalRightSection = () => {
  return (
    <div className="rounded-[12px] h-full w-full tablet:p-6 p-0 tablet:bg-cf-grey-25 tablet:border  tablet:border-cf-transparent-grey-1000-12">
      <div className="text-18 font-bold text-cf-grey-800 w-full text-left flex items-center flex-nowrap">
        <p className="mr-1 whitespace-nowrap"> 2. Help others recreate your project</p>
        <span className="font-normal text-14 text-cf-grey-600">(Optional)</span>
      </div>
      <SkillLevelSelection />
      <div className="mt-4" />
      <MachinesInput />
      <div className="mt-4" />
      <MaterialsInput />
      <div className="mt-4" />
      <ThemesInput />
      <div className="mt-4" />
      <InstructionSection />
    </div>
  )
}
